var angular = require('angular')
var moment = require('moment')

require('../appointment-select-time/appointment-select-time.component.js')
require('../../services/app-data.service.js')

angular.module('AemBranchesAppointments')
  .component('appointmentCalendarDay', {
    template: require('./appointment-calendar-day.component.tpl.html'),
    controller: AppointmentCalendarDayCtrl,
    controllerAs: 'vm',
    bindings: {
      date: '<',
      timeslots: '<'
    }
  })

AppointmentCalendarDayCtrl.$inject = ['appDataService']

function AppointmentCalendarDayCtrl (appDataService) {
  var vm = this

  vm.$onInit = function () {
    vm.dayparts = ['MORNING', 'NOON', 'AFTERNOON', 'EVENING']
    vm.getTimeBoundaries = getTimeBoundaries
    vm.setTimeSelectOpen = appDataService.setTimeSelectOpen
    vm.isTimeSelectOpen = appDataService.isTimeSelectOpen
  }

  vm.$onChanges = function () {
    vm.timeslotsByDaypart = {
      MORNING: getTimeslotsByDaypart(vm.timeslots, 'MORNING'),
      NOON: getTimeslotsByDaypart(vm.timeslots, 'NOON'),
      AFTERNOON: getTimeslotsByDaypart(vm.timeslots, 'AFTERNOON'),
      EVENING: getTimeslotsByDaypart(vm.timeslots, 'EVENING')
    }
    vm.daypartsState = {
      MORNING: getTimeslotsOverallState(vm.timeslotsByDaypart.MORNING),
      NOON: getTimeslotsOverallState(vm.timeslotsByDaypart.NOON),
      AFTERNOON: getTimeslotsOverallState(vm.timeslotsByDaypart.AFTERNOON),
      EVENING: getTimeslotsOverallState(vm.timeslotsByDaypart.EVENING)
    }
  }

  function getTimeslotsByDaypart (timeslots, daypart) {
    return timeslots.filter(function (element) {
      return element.daypartName === daypart
    })
  }

  function getTimeslotsOverallState (timeslots) {
    var free = timeslots.filter(function (element) {
      return element.state === 'FREE'
    }).length
    var occupied = timeslots.filter(function (element) {
      return element.state === 'OCCUPIED'
    }).length

    if (free) {
      return 'FREE'
    } else if (occupied) {
      return 'OCCUPIED'
    } else {
      return 'CLOSED'
    }
  }

  function getTimeBoundaries (timeslots) {
    var format = 'HH:mm'
    return moment(timeslots[0].date, format).format(format) + ' - ' +
      moment(timeslots[timeslots.length - 1].date).add(15, 'minutes').format(format)
  }
}
